import React from "react";

function FooterLinkList({ data }) {
    return (
        <div key={'footer-link-list-'.concat(data['titleLink'].label)} className={'footer-link-list'}>
                <div className={data['links'].length > 0 ? "footer-main-link-title" : "fixed-height-footer-link"}>
                    <strong><a href={data['titleLink'].url}>{data['titleLink'].label}</a></strong>
                </div>
                {data['links'].length > 0 ? data['links'].map((linkItem, linkItemIdx) =>
                        <div key={ linkItemIdx }>
                            <a className="white-text" href={linkItem['url']}>{linkItem['label']}</a>
                        </div>
                    ) : null}
            {data['links'].length > 0 ? <div style={{height: '30px'}}></div> : null}
        </div>

    );
}

export default FooterLinkList;
